<template>
    <div @click="openTencent" v-if="user.tencent_user_ready">
        <img src="~@/assets/images/opentencent.png" alt="open-tencent" :style="{height: height+'px', cursor: 'pointer'}"/>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "open-tencent",
    methods: {
        openTencent() {
            this.$affirm('以' + this.user.name + '身份启动腾讯会议吗?').then(() => {
                this.$api("User.Transfer", {}, 1).then(res => {
                    const url = res.data.data;
                    window.open(url, '_blank');
                });
            });
        }
    },
    computed:{
        ...mapState(['user']),
    },
    props:{
        height: {
            type: Number,
            default: 16
        }
    }
}
</script>

<style scoped>

</style>
